module.exports = __webpack_public_path__ + "img/07@2x.ef627621.png";